export default {
    CanSetFixedSplit: 'CanSetFixedSplit',
    CanManageRecurringPayments: 'CanManageRecurringPayments',
    CanEditBillPayer: 'CanEditBillPayer',
    ShowBillPayerBalance: 'ShowBillPayerBalance',
    ShowBillPayerReferences: 'ShowBillPayerReferences',
    CanManageBillPayerReferences: 'CanManageBillPayerReferences',
    CanManagePaymentsSources: 'CanManagePaymentsSources',
    CanMakeAutomaticPayments: 'CanMakeAutomaticPayments',
    CanDeletePaymentsSource: 'CanDeletePaymentsSource',
    CanDeleteBillPayer: 'CanDeleteBillPayer',
    CanReviveBillPayer: 'CanReviveBillPayer',
    ShowBillPayerBankDetails: 'ShowBillPayerBankDetails',
    LimitedEditBillPayer: 'LimitedEditBillPayer',
    ShowPaymentRemindersWidget: 'ShowPaymentRemindersWidget',
    ShowLinkToTaxStatement: 'ShowLinkToTaxStatement',
};
